import { cn } from '@/lib/utils';

type WorkflowColor = Modules.Workflows.Enums.WorkflowColorEnum;

interface WorkflowBadgeProps {
    name: string;
    color: WorkflowColor | null;
    className?: string;
    showLabel?: boolean;
    truncate?: boolean;
}

const colorMapping: Record<WorkflowColor, string> = {
    red: 'bg-red-500',
    orange: 'bg-orange-500',
    amber: 'bg-amber-500',
    green: 'bg-green-500',
    teal: 'bg-teal-500',
    cyan: 'bg-cyan-500',
    blue: 'bg-blue-500',
    indigo: 'bg-indigo-500',
    purple: 'bg-purple-500',
    fuchsia: 'bg-fuchsia-500',
    pink: 'bg-pink-500',
    slate: 'bg-slate-500',
};

const getColorClass = (color: WorkflowColor | null): string => {
    return (color && colorMapping[color]) || colorMapping.slate;
};

export function WorkflowBadge({ name, color, className = '', showLabel = true, truncate = false }: WorkflowBadgeProps) {
    const hasBorderZero = className.includes('!border-0');

    return (
        <div className={cn('inline-flex items-center gap-2', truncate && 'min-w-0', className)}>
            <div
                className={cn(
                    'inner-shadow relative h-5 w-5 shrink-0 rounded-md shadow-[inset_0_1px_2px_rgba(0,0,0,0.1)]',
                    !hasBorderZero && 'border-weak border bg-[color:var(--background)]',
                )}
            >
                <div className="absolute inset-0 flex items-center justify-center">
                    <span className={cn('h-3 w-3 rounded-[3px]', getColorClass(color))}>
                        <span className="sr-only">{name}</span>
                    </span>
                </div>
            </div>
            {showLabel && <span className={cn('text-sm font-medium', truncate && 'min-w-0 truncate')}>{name}</span>}
        </div>
    );
}
